import {
  CREATE_EDI_RECORD_REQUEST,
  CREATE_EDI_RECORD_SUCCESS,
  CREATE_EDI_RECORD_FAILURE,
  CLEAR_RECORD_CREATED_POPUP,
} from "../actionTypes";

import edi from "../service/cbp";

const createEdiRecord = () => {
  return {
    type: CREATE_EDI_RECORD_REQUEST,
  };
};

const createEdiRecordSuccess = (recordCreated) => {
  return {
    type: CREATE_EDI_RECORD_SUCCESS,
    payload: recordCreated,
  };
};
export const clearRecordCreatedPopup = () => {
  return {
    type: CLEAR_RECORD_CREATED_POPUP,
  };
};

const createEdiRecordFailure = (error) => {
  return {
    type: CREATE_EDI_RECORD_FAILURE,
    payload: error,
  };
};

export const createRecord = (dataRecords, country, usFormType, isPscRequest) => {
  return async (dispatch) => {
    dispatch(createEdiRecord());
    let response = await edi.createEdiRequest(dataRecords, country, usFormType, isPscRequest);
    const recordCreatedMessage = response.data;
    dispatch(createEdiRecordSuccess(recordCreatedMessage));
  };
};
